// Toggle collapse/expand for Price Features tables
(function () {
  var billingEventName = 'sa:team-dtc-pricing:billing-change';
  var planKinds = ['starter', 'pro', 'unlimited', 'team'];
  if (window.__priceFeaturesCleanups) {
    window.__priceFeaturesCleanups.forEach(function (cleanup) {
      cleanup();
    });
  }
  window.__priceFeaturesCleanups = [];

  function getBilling(source) {
    if (!source) return '';
    return source.classList.contains('yearly') ? 'annual' : 'monthly';
  }

  function syncPriceFeaturesPrices(billing) {
    var source = document.querySelector('.sa-team-dtc-pricing');
    if (!source || (billing !== 'monthly' && billing !== 'annual')) return;

    document.querySelectorAll('[data-price-features-root]').forEach(function (root) {
      root.querySelectorAll('[data-price-features-product]').forEach(function (item, index) {
        var planKind = planKinds[index] || '';
        var targetPrice = item.querySelector('[data-price-features-price]');
        var targetPriceUnit = item.querySelector('[data-price-features-price-unit]');
        var hasPriceOverride = item.getAttribute('data-price-features-price-override') === 'true';
        if (!planKind || !targetPrice || hasPriceOverride) return;

        var sourcePrice = source.querySelector(
          '[data-sa-team-dtc-plan="' + planKind + '"][data-sa-team-dtc-billing="' + billing + '"] [data-sa-team-dtc-price]'
        );
        if (!sourcePrice) return;

        targetPrice.textContent = sourcePrice.textContent.trim();
        if (targetPriceUnit) {
          var sourcePriceUnit = source.querySelector(
            '[data-sa-team-dtc-plan="' + planKind + '"][data-sa-team-dtc-billing="' + billing + '"] [data-sa-team-dtc-price-unit]'
          );
          var unitText = sourcePriceUnit ? sourcePriceUnit.textContent.trim() : '';
          targetPriceUnit.textContent = unitText;
          targetPriceUnit.hidden = unitText === '';
        }
      });
    });
  }

  function syncPriceFeaturesButtons(billing) {
    if (billing !== 'monthly' && billing !== 'annual') return;

    document.querySelectorAll('[data-price-features-root]').forEach(function (root) {
      root.querySelectorAll('[data-price-features-button]').forEach(function (group) {
        var options = group.querySelectorAll('[data-price-features-button-option]');
        if (!options.length) return;

        var activeOption =
          group.querySelector('[data-price-features-button-option="' + billing + '"]') ||
          group.querySelector('[data-price-features-button-option="default"]') ||
          options[0];

        options.forEach(function (option) {
          option.hidden = option !== activeOption;
        });
      });
    });
  }

  function syncPriceFeaturesBilling(billing) {
    syncPriceFeaturesPrices(billing);
    syncPriceFeaturesButtons(billing);
  }

  if (window.__priceFeaturesBillingHandler) {
    document.removeEventListener(billingEventName, window.__priceFeaturesBillingHandler);
  }
  window.__priceFeaturesBillingHandler = function (event) {
    if (!event.detail || !event.detail.billing) return;
    syncPriceFeaturesBilling(event.detail.billing);
  };
  document.addEventListener(billingEventName, window.__priceFeaturesBillingHandler);
  if (window.__priceFeaturesSectionUnloadHandler) {
    document.removeEventListener('shopify:section:unload', window.__priceFeaturesSectionUnloadHandler);
  }
  window.__priceFeaturesSectionUnloadHandler = function (event) {
    if (!event.target || !event.target.querySelector('[data-price-features-root]')) return;
    window.__priceFeaturesCleanups.forEach(function (cleanup) {
      cleanup();
    });
    window.__priceFeaturesCleanups = [];
  };
  document.addEventListener('shopify:section:unload', window.__priceFeaturesSectionUnloadHandler);

  function setupItem(item) {
    if (item.getAttribute('data-price-features-initialized') === 'true') return;
    var toggleBtn = item.querySelector('.price-features_header_right');
    if (!toggleBtn) return;

    var content = item.querySelector('.price-features_content');
    if (!content) return;
    item.setAttribute('data-price-features-initialized', 'true');

    // Set initial height for smooth animation (default expanded)
    try {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';
    } catch (e) {}

    toggleBtn.setAttribute('role', 'button');
    toggleBtn.setAttribute('tabindex', '0');
    toggleBtn.setAttribute('aria-expanded', 'true');

    function collapse() {
      item.classList.add('collapsed');
      toggleBtn.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
    }

    function expand() {
      item.classList.remove('collapsed');
      toggleBtn.setAttribute('aria-expanded', 'true');
      try {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.style.opacity = '1';
      } catch (e) {}
    }

    function handleToggleClick() {
      if (item.classList.contains('collapsed')) {
        expand();
      } else {
        collapse();
      }
    }

    function handleToggleKeydown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleBtn.click();
      }
    }

    var resizeTimer;
    function handleResize() {
      if (item.classList.contains('collapsed')) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        try {
          content.style.maxHeight = content.scrollHeight + 'px';
        } catch (e) {}
      }, 100);
    }

    toggleBtn.addEventListener('click', handleToggleClick);
    toggleBtn.addEventListener('keydown', handleToggleKeydown);
    window.addEventListener('resize', handleResize);
    window.__priceFeaturesCleanups.push(function () {
      clearTimeout(resizeTimer);
      toggleBtn.removeEventListener('click', handleToggleClick);
      toggleBtn.removeEventListener('keydown', handleToggleKeydown);
      window.removeEventListener('resize', handleResize);
      item.removeAttribute('data-price-features-initialized');
    });
  }

  function init() {
    var source = document.querySelector('.sa-team-dtc-pricing');
    syncPriceFeaturesBilling(getBilling(source) || 'monthly');
    var items = document.querySelectorAll('.price-features_tables_item');
    items.forEach(setupItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
